import React from "react";
import { Link } from "react-router-dom";
import Close from "../../images/close.png";
import MyDashboard from "../Doctor/myDashboard";

const Modal = () => (
  <div>
    <MyDashboard />
    <div id="id01" className="w3-modal">
      <div className="w3-modal-content position-relative">
        <div className="w3-container">
          <Link to="/doctor/mydashboard" className="modalClose">
            <img src={Close} alt="close" />
          </Link>
          <h2 className="modal_title py-4">Create an Appointments</h2>
          <h6 className="modal_desc">
            Please fill the form in order to create a new appointment for your
            patient.
          </h6>
          <div className="row modal_form_row">
            <div className="col-lg-6 pb-3">
              <div className="form_input">
                <input
                  placeholder="First Name"
                  className="form-control px-3 py-2 h-auto"
                  type="text"
                  id="name"
                  required
                />
                <label className="ml-3" htmlFor="name">
                  First Name
                </label>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form_input">
                <input
                  className="form-control px-3 py-2 h-auto"
                  placeholder="Last Name"
                  type="text"
                  id="surname"
                  required
                />
                <label className="ml-3" htmlFor="surname">
                  Last Name
                </label>
              </div>
            </div>
          </div>
          <div className="row ">
            <div className="col-lg-6 pb-3">
              <div className="form_input">
                <input
                  placeholder="First Name"
                  className="form-control px-3 py-2 h-auto"
                  type="date"
                  id="date"
                  required
                />
                <label className="ml-3" htmlFor="date">
                  Pick a Date{" "}
                </label>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form_input">
                <select
                  name="time"
                  id="time"
                  className="form-control px-3 py-2 h-auto"
                >
                  <option value="volvo">Volvo</option>
                  <option value="saab">Saab</option>
                  <option value="opel">Opel</option>
                  <option value="audi">Audi</option>
                </select>
                <label className="ml-3" htmlFor="time">
                  Select a Time Slot{" "}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="form__group">
          <span className="radio_title mr-3">Video Consultation:</span>
          <span>
            <div className="form__radio-group">
              <input
                type="radio"
                className="form__radio-input"
                id="small"
                name="size"
              />
              <label htmlFor="small" className="form__radio-label">
                <span className="form__radio-botton"></span>
                <span>Yes</span>{" "}
              </label>
            </div>
            <div className="form__radio-group">
              <input
                type="radio"
                className="form__radio-input"
                id="large"
                name="size"
              />
              <label htmlFor="large" className="form__radio-label">
                <span className="form__radio-botton"></span>
                <span>No</span>{" "}
              </label>
            </div>
          </span>
        </div>
        <center>
          <button className="btn font-weight-bold btn-theme text-uppercase font-smaller py-2 my-3 px-3 btn-dark">
            {" "}
            create an appointment
          </button>
        </center>
      </div>
    </div>
  </div>
);
export default Modal;
